import React from 'react';

import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';
import { CalendarPortal } from 'components/form/managed_input/date_input';

import type { DateFilter, FilterProps } from './types';

export default function CompCustomFieldDateFilter({ filter = {}, schema, onChange }: FilterProps<DateFilter>) {
  return (
    <div className="form-group">
      <FilterDatePickerPair
        class
        filter={filter}
        label={schema.label}
        popperContainer={CalendarPortal}
        valueKeys={['min', 'max']}
        onChange={(value: string, key: string) => onChange({ ...filter, [key]: value })}
      />
    </div>
  );
}
